export const CHECKBOX_STATES = {
  checked: 'checked',
  indeterminate: 'indeterminate',
  empty: 'empty'
} as const;
